<template>
	<div class="workflow-container-custom-content custom-step-section">
		<div class="workflow-container-body">
			<div class="wf-body-column">
				<input-area
					data-print="disabled"
					name="add-step"
					tag="textarea"
					label="Description"
					v-model="customContent.desc"
					@inputChanged="updateCustomDesc"
					class="add-step-textarea"
					maxlength="600"
				/>
				<div v-html="printableCustomDesc" class="printable-description" data-print="enabled" />
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: 'CustomStep',
	props: {
		customContent: {
			type: Object,
		},
		name: {
			type: String,
		},
	},
	methods: {
		updateCustomDesc() {
			this.$store.dispatch('workflow/setCustomStepDesc', {name: this.name, desc: this.customContent.desc});
		},
	},
	computed: {
		printableCustomDesc() {
      if(!this.customContent.desc) {
        return ''
      }

			return this.customContent.desc
				.split('\n')
				.filter((paragraph) => paragraph)
				.map((paragraph) => `<p>${paragraph}</p>`)
				.toString()
				.replace(/,/g, '');
		},
	},
};
</script>
<style lang="scss">
.workflow-container-custom-content {
	&.custom-step-section {
		.wf-body-column {
			flex: 1;
			padding: 20px 0 16px 0;
			@media only screen and (max-width: $mobile) {
				padding: 24px 24px;
			}
		}
		textarea {
			max-height: 300px;
		}
		.printable-description[data-print='enabled'] {
			visibility: hidden;
			display: none;
			height: 0px;
			margin: 12px 0;
			p {
				padding: 0 !important;
				margin: 0 !important;
				word-break: break-all;
			}
		}
	}
}
</style>
